export default __webpack_public_path__ + "static/media/aboutSection1banner.4fe02ef5.png";